import React from "react";

import {p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {OfferType} from "../../offer/types/OfferType";
import {Country} from "../../region/types/Country";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {ISelectedRegionList} from "../interfaces/ISelectedRegionList";
import {ISiteMapLinkWithOfferCount} from "../interfaces/ISiteMapLinkWithOfferCount";
import {getRegionOfferCountByOfferType} from "../utils/get_region_offer_count_by_offer_type";
import {isCollectionEmpty} from "../utils/is_collection_empty";
import {siteMapLinkDefinedPrefixes, SiteMapLinkList} from "./SiteMapLinkList";

interface IProps {
    offerType: OfferType;
    regionAsLink?: boolean;
    regions: ISelectedRegionList[];
    subregionName: "counties" | "aggregations" | "cities";
    country?: Country;
}

const isLinkObject = (value: unknown): value is ISiteMapLinkWithOfferCount => Boolean(value);

const getOfferLink = (offerType: OfferType, region?: string, country?: Country) => {
    const {friendlySlug, countrySlug} = offerUrlBuilder({
        type: offerType,
        region: region ? region : "",
        ...(country ? {country: country} : {})
    });

    return country && country !== Country.POLAND
        ? rpAppLink.offer.listFriendlyAbroad({
              friendlySlug: friendlySlug,
              country: countrySlug,
              abroadRegionSlug: region
          })
        : rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
};

const getSubregionLinks = (offerType: OfferType, subregionList: ISitemapRegionListRegion[], country?: Country) => {
    const subregionLinks = subregionList.map((subregion) => {
        const offerCount = getRegionOfferCountByOfferType(subregion, offerType);

        const link = getOfferLink(offerType, subregion.slug, country);

        return offerCount
            ? {
                  href: link,
                  text: subregion.name,
                  offerCount
              }
            : null;
    });

    return subregionLinks.filter<ISiteMapLinkWithOfferCount>(isLinkObject);
};

export const SiteMapSubregionList = (props: IProps) => {
    return (
        <>
            {props.regions.map((region) => {
                if (isCollectionEmpty(props.offerType, region[props.subregionName])) {
                    return null;
                }

                const links = getSubregionLinks(props.offerType, region[props.subregionName], props.country);
                return (
                    <div key={region.name}>
                        <Text as="h3" variant="headline_6" css={[p(3, 3, 0)]}>
                            {props.regionAsLink ? <a href={getOfferLink(props.offerType, region.slug, props.country)}>{region.name}</a> : <>{region.name}</>}
                        </Text>
                        <SiteMapLinkList variant="body_copy_2" textPrefix={siteMapLinkDefinedPrefixes.bullet} gap={1} links={links} />
                    </div>
                );
            })}
        </>
    );
};
import React from "react";

import {p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {OfferType} from "../../offer/types/OfferType";
import {Country} from "../../region/types/Country";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {ISelectedRegionList} from "../interfaces/ISelectedRegionList";
import {ISiteMapLinkWithOfferCount} from "../interfaces/ISiteMapLinkWithOfferCount";
import {getRegionOfferCountByOfferType} from "../utils/get_region_offer_count_by_offer_type";
import {isCollectionEmpty} from "../utils/is_collection_empty";
import {siteMapLinkDefinedPrefixes, SiteMapLinkList} from "./SiteMapLinkList";

interface IProps {
    offerType: OfferType;
    regionAsLink?: boolean;
    regions: ISelectedRegionList[];
    subregionName: "counties" | "aggregations" | "cities";
    country?: Country;
}

const isLinkObject = (value: unknown): value is ISiteMapLinkWithOfferCount => Boolean(value);

const getOfferLink = (offerType: OfferType, region?: string, country?: Country) => {
    const {friendlySlug, countrySlug} = offerUrlBuilder({
        type: offerType,
        region: region ? region : "",
        ...(country ? {country: country} : {})
    });

    return country && country !== Country.POLAND
        ? rpAppLink.offer.listFriendlyAbroad({
              friendlySlug: friendlySlug,
              country: countrySlug,
              abroadRegionSlug: region
          })
        : rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
};

const getSubregionLinks = (offerType: OfferType, subregionList: ISitemapRegionListRegion[], country?: Country) => {
    const subregionLinks = subregionList.map((subregion) => {
        const offerCount = getRegionOfferCountByOfferType(subregion, offerType);

        const link = getOfferLink(offerType, subregion.slug, country);

        return offerCount
            ? {
                  href: link,
                  text: subregion.name,
                  offerCount
              }
            : null;
    });

    return subregionLinks.filter<ISiteMapLinkWithOfferCount>(isLinkObject);
};

export const SiteMapSubregionList = (props: IProps) => {
    return (
        <>
            {props.regions.map((region) => {
                if (isCollectionEmpty(props.offerType, region[props.subregionName])) {
                    return null;
                }

                const links = getSubregionLinks(props.offerType, region[props.subregionName], props.country);
                return (
                    <div key={region.name}>
                        <Text as="h3" variant="headline_6" css={[p(3, 3, 0)]}>
                            {props.regionAsLink ? <a href={getOfferLink(props.offerType, region.slug, props.country)}>{region.name}</a> : <>{region.name}</>}
                        </Text>
                        <SiteMapLinkList variant="body_copy_2" textPrefix={siteMapLinkDefinedPrefixes.bullet} gap={1} links={links} />
                    </div>
                );
            })}
        </>
    );
};
